<template> 

  <div>
 
    <Loader text="Ładowanie aplikacji" v-if="!user.id" />

    <div class="container pt-4" v-if="user.id">

      <h2 class="fw-600">Aplikacje</h2>

      <b-row>

        <!--<b-col lg="3" class="mt-5">
          Moje kurszy<br/>
          Wszystkie kursy<br/>
          <hr/>
          <small class="text-uppercase">Kategorie</small><br/><br/>
          TikTok<br/>
          Instagram<br/>
          Facebook<br/>
          E-marketing<br/>
          Copywriting<br/>
        </b-col>-->

        <b-col lg="12" class="pb-5">
  
          <div class="d-flex align-items-center mt-5 mb-3">
            <b-form-input
              v-model="search"
              placeholder="Szukaj aplikacji..."
              class="mr-3"
              style="max-width: 850px;"
            ></b-form-input>
            <b-form-select
              v-model="selectedPackage"
              :options="[{ value: null, text: 'Wszystkie aplikacje' }, ...packages.map(pkg => ({ value: pkg.name, text: pkg.name }))]"
              class="ml-2"
              style="max-width: 250px;"
            ></b-form-select>
          </div>

          <b-row class="d-flex">

            <b-col class="mt-3 d-flex" lg="3" sm="6" cols="6" v-for="item in sortedItems()" :key="item.slug">

              <b-card no-body class="overflow-hidden">
                
                <b-card-body>
 
                  <img :src="item.cover" style="width:100%;" class="mb-3"/>
                  
                  <h6 class="font-weight-bold" v-if="item.isBestseller">
                    <b-link :to="('/app/' + item.slug + '/')" class="text-dark">
                      <b-badge variant="success">BESTSELLER</b-badge> 
                    </b-link>
                  </h6>

                  <b-card-text class="small">

                    <div class="text-center mb-2">{{ item.subtitle }}</div>

                    <div style="color: #898989;" v-if="item.showMetaData">
                      <span class="material-symbols-sharp align-middle" style="font-size: 1rem;">widgets</span> &nbsp; {{ item.addons.length }} dodatków<br/>
                    </div>
                    
                    <div style="height:100%;">
                      <div v-if="user.permissions.includes(item.neededPermissions)" class="text-center text-success">
                        <span class="material-symbols-sharp align-middle" style="font-size: 1rem;">check_circle</span> Masz dostęp 

                        <b-button class="mt-2" variant="light" :to="('/app/' + item.slug + '/')" block size="sm" v-if="!item.isOldApp">Przejdź do aplikacji</b-button>
                        <b-button class="mt-2" variant="light" :href="(item.oldLink)" block size="sm" v-if="item.isOldApp">Przejdź do aplikacji</b-button>
                      </div> 

                      <div v-if="!user.permissions.includes(item.neededPermissions)" class="text-center text-danger">
                        <span class="material-symbols-sharp align-middle" style="font-size: 1rem;">info</span> Nie masz dostępu 

                        <b-button class="mt-2" variant="success" :href="(item.buyLink)" block size="sm">Uzyskaj dostęp</b-button>
                      </div> 
                    </div>

                  </b-card-text>

                </b-card-body>
  
              </b-card>

            </b-col>

          </b-row>

        </b-col>

      </b-row>

    </div>
  </div>
</template>

<script>
import Loader from '../../elements/Loader';

export default {
  name: 'SectionApps',
  components: {
     Loader
  },
  data() {
    return {
      apps: [],
      selectedPackage: null,
      packages: [
        {
          name: "Akademia Social Media",
          permissions: [
            "app.apps.bg-ai-sm-machine",
            "app.apps.persona-creator",
            "app.apps.hashtag-generator",
            "app.apps.insta-tag",
            "app.apps.neuro-copy",
            "app.apps.fb-targeting",
            "app.apps.emoji-inspirator",
            "app.apps.fb-ads",
            "app.apps.benefit-generator",
            "app.apps.headline-generator",
            "app.apps.video-selling-machine",
            "app.apps.youtube-title-generator",
            "app.apps.core-influence",
            "app.apps.insta-bio-generator"
          ]
        },
        {
          name: "1 IPhone Photo Video Masterclass",
          permissions: [
            "app.apps.creative-photo-idea",
            "app.apps.photo-to-prompt",
            "app.apps.photo-mentor-ai",
            "app.apps.100-photo-ideas"
          ]
        },
        {
          name: "1 Milion Biznes AI",
          permissions: [
            "app.apps.bg-ai",
            "app.apps.bg-ai-avatar-generator",
            "app.apps.bg-ai-empathy-map-gen",
            "app.apps.bg-ai-niche-gen",
            "app.apps.bg-ai-ask-ai",
            "app.apps.bg-ai-problem-solve-gen",
            "app.apps.bg-ai-form-generator-ai",
            "app.apps.bg-ai-microproblems-gen-ai",
            "app.apps.bg-ai-pain-point-gen",
            "app.apps.bg-ai-sm-strategist",
            "app.apps.bg-ai-fb-post-gen",
            "app.apps.bg-ai-fb-group-post-gen",
            "app.apps.bg-ai-insta-post-gen",
            "app.apps.bg-ai-threads-gen",
            "app.apps.bg-ai-edu-stories-gen",
            "app.apps.bg-ai-reels-gen",
            "app.apps.bg-ai-faceless-reels-gen",
            "app.apps.bg-ai-tt-gen",
            "app.apps.bg-ai-linked-post-gen",
            "app.apps.bg-ai-yt-gen-ai",
            "app.apps.bg-ai-article-blog-gen",
            "app.apps.bg-ai-newsletter-gen",
            "app.apps.bg-ai-x-gen",
            "app.apps.bg-ai-lead-magnet-gen",
            "app.apps.bg-ai-free-raport-gen",
            "app.apps.bg-ai-landing-pages-gen",
            "app.apps.bg-ai-welcome-email-gen",
            "app.apps.bg-ai-social-post-gen",
            "app.apps.bg-ai-engagement-stories-gen",
            "app.apps.bg-ai-comment-gen-ai",
            "app.apps.bg-ai-respond-gen",
            "app.apps.bg-ai-question-stories-gen",
            "app.apps.bg-ai-product-gen",
            "app.apps.bg-ai-bussines-model-gen",
            "app.apps.bg-ai-innovation-gen",
            "app.apps.bg-ai-name-product-gen",
            "app.apps.bg-ai-market-analizer-ai",
            "app.apps.bg-ai-usp-gen",
            "app.apps.bg-ai-sell-idea-gen",
            "app.apps.bg-ai-selling-post-gen",
            "app.apps.bg-ai-offer-gen",
            "app.apps.bg-ai-marketing-planner-gen",
            "app.apps.bg-ai-facebook-ads-gen",
            "app.apps.bg-ai-email-selling-gen",
            "app.apps.bg-ai-phone-script-gen",
            "app.apps.bg-ai-scaling-bussines-ai",
            "app.apps.bg-ai-delegation-ai",
            "app.apps.bg-ai-ltv-gen",
            "app.apps.bg-ai-product-ladder-gen",
            "app.apps.bg-ai-opti-budget-ai",
            "app.apps.bussines-planner-ai",
            "app.apps.daily-routine-ai",
            "app.apps.youtube-planner-ai",
            "app.apps.celebrilty-post-ai",
            "app.apps.procrastination-stoper-ai",
            "app.apps.summarizer-ai",
            "app.apps.biznes-assistant-ai",
            "app.apps.copy-genius",
            "app.apps.social-media-calendar",
            "app.apps.millionaire-mindset-generator",
            "app.apps.business-calculator-2",
            "app.apps.graphic-prompt-creator",
            "app.apps.graphic-nn-ai",
            "app.apps.ai-post-creator"
          ]
        },
        {
          name: "1 Milion Content AI",
          permissions: [
            "app.apps.seo-writer-ai",
            "app.apps.blog-post-ai",
            "app.apps.bussines-mentor-ai",
            "app.apps.biz-brain-ai",
            "app.apps.article-headline-ai",
            "app.apps.headline-booster",
            "app.apps.ask-ai",
            "app.apps.article-genius-ai",
            "app.apps.korektor-ai",
            "app.apps.motivational-post-ai",
            "app.apps.virtualo-ai",
            "app.apps.post-calendar-generator",
            "app.apps.ai-post-creator",
            "app.apps.someai-writer",
            "app.apps.graphic-ai-g",
            "app.apps.new-house-ai",
            "app.apps.znajdz-prace-ai",
            "app.apps.photo-fx-ai",
            "app.apps.flat-lay-generator-ai",
            "app.apps.blog-graphic-generator",
            "app.apps.graphic-ai-new"
          ]
        },
        {
          name: "1 Milion Course AI",
          permissions: [
            "app.apps.slide-generator",
            "app.apps.quizz-generator-ai",
            "app.apps.module-title-generator-ai",
            "app.apps.mind-map-generator-ai",
            "app.apps.expert-genius-ai",
            "app.apps.email-selling-sequence-ai",
            "app.apps.course-validator-ai",
            "app.apps.course-title-generator-ai",
            "app.apps.course-planner-ai",
            "app.apps.course-offer-generator-ai",
            "app.apps.course-idea-generator-ai",
            "app.apps.course-assistant-ai",
            "app.apps.course-1m-calculator-ai",
            "app.apps.business-calculator",
            "app.apps.ai-course-generator",
            "app.apps.ai-post-creator",
          ]
        },
        {
          name: "1 Milion E-book AI",
          permissions: [
            "app.apps.style-cloner-ai",
            "app.apps.storyteller-ai",
            "app.apps.chapter-title-generator-ai",
            "app.apps.ebook-selling-checker-ai",
            "app.apps.outro-ebook-generator-ai",
            "app.apps.intro-book-generator-ai",
            "app.apps.ebook-article-ai",
            "app.apps.ebook-xxl-ai",
            "app.apps.ebook-assistant-ai",
            "app.apps.ebook-promo-calendar",
            "app.apps.ebook-email-sequence-ai",
            "app.apps.ebook-offer-generator-ai",
            "app.apps.video-to-ebook-ai",
            "app.apps.ebook-promotor-ai",
            "app.apps.ebook-sales-funnel",
            "app.apps.ilustrator-ai",
            "app.apps.author-ai",
            "app.apps.contents-generator-ai",
            "app.apps.ebook-title-generator-ai",
            "app.apps.ebook-idea-generator-ai",
            "app.apps.ai-ebook-generator",
            "app.apps.ai-post-creator",
            "app.apps.graphic-n-ai",
            "app.apps.ebook-cover-generator"
          ]
        },
        {
          name: "1 Milion Graphic i Video AI",
          permissions: [
            "app.apps.freelance-graphic-ai",
            "app.apps.social-app-ai",
            "app.apps.video-avatar-ai",
            "app.apps.pixel-ai-f",
            "app.apps.hashtag-generator-ai",
            "app.apps.image-to-post-ai",
            "app.apps.instagram-audytor-ai",
            "app.apps.midjourney-prompt-generator",
            "app.apps.copywriter-ai",
            "app.apps.post-generator-ai",
            "app.apps.graphic-ai-sweep",
          ]
        },
        {
          name: "Grafik 10K Online",
          permissions: [
            "app.apps.10k-generator-ai",
            "app.apps.beauty-retouch-ai",
            "app.apps.course-bundle-generator-ai",
            "app.apps.facebook-graphic-ai",
            "app.apps.logo-creator-ai",
            "app.apps.money-idea-generator-ai",
            "app.apps.photo-mixer-ai",
            "app.apps.photo-model-ai",
            "app.apps.photo-product-ai",
            "app.apps.quote-ai",
            "app.apps.remover-ai",
            "app.apps.time-machine-ai",
            "app.apps.youtube-thumbnail-generator",
            "app.apps.client-money-ai",
            "app.apps.veedeo-ai",
            "app.apps.imagio-ai",
            "app.apps.hashtager-ai",
            "app.apps.photo-poster-ai",
            "app.apps.some-audytor",
            "app.apps.nano-banana-prompt-generator",
            "app.apps.writer-ai2",
            "app.apps.post-creator-ai2",
            "app.apps.graphic-prompt-revers"
          ]
        },
        {
          name: "1 Milion Webinar AI",
          permissions: [
            "app.apps.audience-targeting-ai",
            "app.apps.bonus-generator-ai",
            "app.apps.challenge-generator-ai",
            "app.apps.crushing-objections-ai",
            "app.apps.education-webinar-ai",
            "app.apps.email-education-generator-ai",
            "app.apps.emails-inviting-ai",
            "app.apps.engagement-booster-ai",
            "app.apps.qa-session-generator-ai",
            "app.apps.reels-webinar-generator-ai",
            "app.apps.selling-argument-generator-ai",
            "app.apps.sm-webinar-promotor",
            "app.apps.video-script-ai",
            "app.apps.webinar-ads-generator-ai",
            "app.apps.webinar-agenda-ai",
            "app.apps.webinar-assistance-ai",
            "app.apps.webinar-funnel-generator-ai",
            "app.apps.webinar-graphic-ai",
            "app.apps.webinar-idea-ai",
            "app.apps.webinar-presention-ai",
            "app.apps.webinar-title-generator-ai",
            "app.apps.webinar-validator-ai",
            "app.apps.ai-post-creator",
            "app.apps.graphic-ai"
          ]
        },
        {
          name: "ChatGPT Masterclass",
          permissions: [
            "app.apps.ai-army",
            "app.apps.ai-cleaner",
            "app.apps.general-prompt-creator-ai",
            "app.apps.prompt-coach-ai",
            "app.apps.prompt-hero-ai",
            "app.apps.super-prompt-generator"
          ]
        },
        {
          name: "Pakiet 58 aplikacji",
          permissions: [
            "app.apps.fanpage-selling-machine",
            "app.apps.neuro-copy",
            "app.apps.benefit-generator",
            "app.apps.headline-generator",
            "app.apps.video-selling-machine",
            "app.apps.post-creator",
            "app.apps.insta-story-creator",
            "app.apps.fb-ads",
            "app.apps.fb-targeting",
            "app.apps.hashtag-generator",
            "app.apps.emoji-inspirator",
            "app.apps.persona-creator",
            "app.apps.youtube-title-generator",
            "app.apps.insta-tag",
            "app.apps.fb-copy",
            "app.apps.insta-bio-generator",
            "app.apps.swot-generator",
            "app.apps.offer-generator",
            "app.apps.empathy-map",
            "app.apps.facebook-ads-generator",
            "app.apps.core-influence",
            "app.apps.insta-followers-machine",
            "app.apps.lead-blog-generator",
            "app.apps.viral-tiktok-generator",
            "app.apps.viral-calculator",
            "app.apps.viral-reels-generator",
            "app.apps.post-calendar",
            "app.apps.e-com-generator",
            "app.apps.forum",
            "app.apps.business-calculator",
            "app.apps.avatar-generator",
            "app.apps.social-media-strategist",
            "app.apps.post-idea-generator",
            "app.apps.lead-magnet-generator",
            "app.apps.business-model-generator",
            "app.apps.follow-up-generator",
            "app.apps.ebook-generator",
            "app.apps.funnel-checklist",
            "app.apps.ebook-ads-generator",
            "app.apps.local-ads-generator",
            "app.apps.business-generator",
            "app.apps.promos-generator",
            "app.apps.influencer-generator",
            "app.apps.graphic-ai",
            "app.apps.headline-generator-ai",
            "app.apps.offer-generator-ai",
            "app.apps.prompt-generator",
            "app.apps.copy-puzzle-ai",
            "app.apps.copy-legend-ai",
            "app.apps.copy-booster-ai",
            "app.apps.meme-generator-ai",
            "app.apps.copy-assistant-ai",
            "app.apps.reels-keywords-generator",
            "app.apps.ai-post-creator",
            "app.apps.ai-selling-machine",
            "app.apps.someai-writer",
            "app.apps.virtual-assistance-ai",
            "app.apps.celebrity-post-writer-ai",
            "app.apps.translator-ai"
          ]
        },
        {
          name: "Zarabianie na AI",
          permissions: [
            "app.apps.zarabianie.copy-master-ai2",
            "app.apps.zarabianie.prompt-reverse-ai",
            "app.apps.zarabianie.mini-ebook-generator",
            "app.apps.zarabianie.mini-course-money",
            "app.apps.zarabianie.prompt-money",
            "app.apps.zarabianie.100-first-post-ai",
            "app.apps.zarabianie.personal-brand-generator",
            "app.apps.zarabianie.startup-generator",
            "app.apps.zarabianie.client-magnet",
            "app.apps.zarabianie.virtual-influencer",
            "app.apps.zarabianie.coloring-book-idea",
            "app.apps.zarabianie.colorify-kids",
            "app.apps.zarabianie.youtube-ai-generator",
            "app.apps.zarabianie.some-graphic-generator",
            "app.apps.zarabianie.reels-generator",
            "app.apps.zarabianie.facebook-post-generator",
            "app.apps.zarabianie.retoucher-ai",
            "app.apps.zarabianie.notices-money-generator",
            "app.apps.zarabianie.fast-money-generator",
            "app.apps.zarabianie.foto-money-ai",
            "app.apps.zarabianie.generator-opisow-ecom",
            "app.apps.zarabianie.foto-alive-ai",
            "app.apps.zarabianie.ile-zarobie",
            "app.apps.zarabianie.colorizer-ai",
            "app.apps.zarabianie.sharp-photo-ai"
          ]
        }
      ],
      sortBy: 'order',
      sortDirection: 'asc',
      search: '',
      user: {
        id: null,
        permissions: []
      }
    }
  },

  mounted() {


  },
  created() {
     
    this.axios.get(window.API_URL + "user", { withCredentials: true }).then((response) => {

      let data = response.data 

      if(data.redirectTo) {

        top.location.href = data.redirectTo;

      }

      if(data.userId) {

        this.user.id = data.userId
        this.user.permissions = data.permissions
       

        this.axios.get(window.API_URL + "apps/getAllApps").then((response) => {

          let data = response.data

          data.data.forEach(element => {

            this.axios.get(window.API_URL + "apps/getApp/" + element.slug).then((response) => {

              var add = response.data;
              add.order = element.order;

              add.neededPermissions = element.neededPermissions;

              if(!add.isHidden) {

                if(add.showOnlyIfHasAPerms) {

                  if(this.user.permissions.includes(add.neededPermissions)) {

                    this.apps.push(add)

                  }

                } else {

                  this.apps.push(add)

                }

              }

            })

          })

        })


      }

    });



    // Set breadcumbs
    this.$root.$emit('system.breadcumber.set', [{label: "Aplikacje", link: "/apps"}])

  },
  methods: {
       
    sortedItems: function (){
      let search = this.search.toLowerCase();
      let arr = this.apps;

      // Filtrowanie po pakiecie
      if (this.selectedPackage) {
        // Znajdź wybrany pakiet
        const selected = this.packages.find(pkg => pkg.name === this.selectedPackage);
        if (selected) {
          arr = arr.filter(app => selected.permissions.includes(app.neededPermissions));
        }
      }

      // Filtrowanie po wyszukiwaniu
      if (search) {
        arr = arr.map(object => {
          object.name = object.name.toLowerCase();
          return object;
        });
        arr = arr.filter(function(el) {
          return el.name.indexOf(search) > -1;
        });
      }

      return arr.slice().sort(function(a, b){
        return (a.order > b.order) ? 1 : -1;
      });
    }
      
  }
 
}
</script>

  